import { useSearchParams } from 'react-router-dom';

import type { Params } from './api';
import { toQuery } from './api';

export const RANGES = {
  overview: [
    { value: '24h', label: '24h' },
    { value: '7d', label: '7d' },
    { value: '30d', label: '30d' },
    { value: '90d', label: '90d' },
  ],
  standard: [
    { value: '7d', label: '7d' },
    { value: '30d', label: '30d' },
    { value: '90d', label: '90d' },
  ],
  cost: [
    { value: '7d', label: '7d' },
    { value: '30d', label: '30d' },
    { value: '90d', label: '90d' },
    { value: 'month', label: 'This month' },
  ],
  journeys: [
    { value: '30d', label: '30d' },
    { value: '90d', label: '90d' },
    { value: '180d', label: '180d' },
  ],
};

export function useParam(name: string, fallback: string): [string, (value: string | null) => void] {
  const [params, setParams] = useSearchParams();
  const value = params.get(name) ?? fallback;
  const set = (next: string | null) =>
    setParams(
      (current) => {
        const updated = new URLSearchParams(current);
        if (next === null || next === fallback) updated.delete(name);
        else updated.set(name, next);
        return updated;
      },
      { replace: true },
    );
  return [value, set];
}

export function useCustomers(): [boolean, (value: boolean) => void] {
  const [value, set] = useParam('customers', 'true');
  return [value !== 'false', (next) => set(next ? 'true' : 'false')];
}

export function feedHref(params: Params): string {
  return `/feed${toQuery(params)}`;
}
